import React from 'react'
import { cn } from 'lib/utils'
import { Textarea } from 'components/ui/textarea'
import { Label } from 'components/ui/label'

export default function InputMulti(props) {
	const { name, label, value, defaultValue, error = null, onChange, className, ...other } = props

	return (
		<div className={cn('tw-form-control w-full', className)}>
			{label && (
				<Label htmlFor={name} className="mb-1.5">
					{label}
				</Label>
			)}
			<Textarea
				name={name}
				value={value ?? ''}
				defaultValue={defaultValue}
				rows={2}
				onChange={onChange}
				className={cn(error && 'border-destructive focus-visible:ring-destructive')}
				{...other}
			/>
			{error && <p className="mt-1 text-xs text-destructive">{error}</p>}
		</div>
	)
}
